import { useGetAssessmentProgresses } from "@/api/console/assessment-progresses/useGetAssessmentProgresses";
import AdminNavbar from "@/components/AdminNavbar/AdminNavbar";
import { STATUS } from "@/config/progress";
import ReassessmentTable from "@/src/console/(auth)/(confirm-assessments)/re-assessments/_components/ReassessmentTable";
import { useTranslation } from "react-i18next";

function ConfirmReAssessments() {
  const { t } = useTranslation();
  const { data, isLoading } = useGetAssessmentProgresses(
    `${STATUS.RE_ASSESSMENT_EVALUATION_COMPLETED}`,
  );

  const reassessments = data?.data || [];

  const breadcrumbs = [
    {
      name: t("confirm-re-assessments"),
      href: "/console/confirm-re-assessments",
    },
  ];

  return (
    <>
      <AdminNavbar breadcrumbs={breadcrumbs} />
      <div className=" mx-6 mt-8 my-heading">{t("re-assessments")}</div>
      <div className="mx-6 my-8">
        <ReassessmentTable data={reassessments} isLoading={isLoading} />
      </div>
    </>
  );
}

export default ConfirmReAssessments;
